angular.module('app')
  .directive('googlePlace', function () {
    return {
      restrict: 'A',
      scope: {
        ngModel: '=',
        place: '=googlePlace',
        options: '=?',
        onPlaceChanged: '&',
        attachToElement: '@',
      },
      link(scope, element, attrs) {
        // Australia's bounds
        const bounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(-44.156943, 112.373678),
          new google.maps.LatLng(-10.193732, 153.930143)
        );

        const autocomplete = new google.maps.places.Autocomplete(element[0], { bounds, ...scope.options });

        if (scope.attachToElement === 'true') {
          element.on('focus', function () {
            $(element.parent()).append($('.pac-container'));
          });
        }

        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();

          scope.$apply(() => {
            scope.ngModel = element.val();

            scope.place = {
              name: scope.ngModel,
            };

            if (place.address_components) {
              scope.place.address_components = place.address_components;
            }

            if (place.geometry && place.geometry.location) {
              scope.place.geometry = { location: place.geometry.location };
            }
          });

          scope.onPlaceChanged({ place });
        });

        element.on('focus', () => {
          element.attr('autocomplete', element.attr('name'));
        });
      },
    };
  });
